import { useContext, useEffect, useState } from "react";

import { Row, Col, Card, Avatar } from "antd";

import BgProfile from "../assets/images/bg-profile.jpg";
import { contextApp } from "../firebase/context";

function Profile() {
  const { usuario } = useContext(contextApp);
  const [nombre, setnombre] = useState(null);
  const [imageURL, setImageURL] = useState(null);

  useEffect(() => {
    user();
    image();
  }, [usuario]);

  const user = () => {
    usuario
      ? usuario.displayName
        ? setnombre(usuario.displayName)
        : setnombre(usuario.email)
      : setnombre(null);
  };
  const image = () => {
    usuario
      ? usuario.photoURL
        ? setImageURL(usuario.photoURL)
        : setImageURL("https://joeschmoe.io/api/v1/random")
      : setImageURL(null);
  };

  return (
    <>
      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24, 0]}>
            <Col span={24} md={12} className="col-info">
              <Avatar.Group>
                <Avatar size={74} shape="square" src={imageURL} />

                <div className="avatar-info">
                  <h4 className="font-semibold m-0">{nombre}</h4>
                </div>
              </Avatar.Group>
            </Col>
          </Row>
        }
      ></Card>
    </>
  );
}

export default Profile;
